
export const sponsorsData = [
  {
    name: 'VOGUE',
    category: 'Media Partner'
  },
  {
    name: 'LVMH',
    category: 'Presenting Sponsor'
  },
  {
    name: 'CARIBBEAN AIRLINES',
    category: 'Official Airline'
  },
  {
    name: 'AMERICAN EXPRESS',
    category: 'Payment Partner'
  },
  {
    name: 'MOET & CHANDON',
    category: 'Beverage Partner'
  },
  {
    name: 'MERCEDES-BENZ',
    category: 'Automotive Partner'
  },
  {
    name: 'CASA DE CAMPO',
    category: 'Hospitality Partner'
  },
  {
    name: 'SEPHORA',
    category: 'Beauty Partner'
  }
];
